import axiosClient from './axiosClient';

/** Public discovery — no auth required. */
const searchService = {
  technicianTypes: () => axiosClient.get('/public/technician-types'),

  /** filters: { keyword, technicianTypeId, city, state, maxHourlyRate, minRating, availableOnly, page, size, sortBy, sortDirection } */
  searchTechnicians: (filters = {}) =>
    axiosClient.post('/public/technicians/search', filters),

  /** REST-style variant driven by query params. */
  listTechnicians: (params = {}) => axiosClient.get('/technicians', { params }),

  getTechnician: (id) => axiosClient.get(`/technicians/${id}`),

  technicianReviews: (id, page = 0, size = 20) =>
    axiosClient.get(`/technicians/${id}/reviews`, { params: { page, size } }),

  nearby: (latitude, longitude, radiusKm) =>
    axiosClient.get('/public/technicians/nearby', {
      params: { latitude, longitude, radiusKm },
    }),
};

export default searchService;
